import { Button, Component, Label, Node, _decorator } from 'cc';
import Game from '../../Game';
import ValueToggleSelector from '../Components/ValuePicker/ValueToggleSelector';
import ValueSelector from '../Helper/ValueSelector';
import BaseTool from './BaseTool';

const { ccclass, property } = _decorator;

@ccclass('ToolBar')
export default class ToolBar extends Component {
    @property(ValueToggleSelector)
    private readonly displayToolSelector: ValueToggleSelector = null;

    @property(Node)
    private readonly view: Node = null;

    @property(Node)
    private readonly toolRoot: Node = null;

    private _tools: BaseTool[] = [];
    private _displayToolIndexSelector: ValueSelector<number> = new ValueSelector<number>([0]);

    public get isVisible(): boolean {
        return this.view.active;
    }

    public onLoad() {
        this.displayToolSelector.init(
            this._displayToolIndexSelector,
            (option, value) => {
                const tool = this._tools[value];
                const displayNameLabel = option.getComponentInChildren(Label);
                tool.setupDisplayNameLabel(displayNameLabel);
            },
            (option, isSelected) => {
                const tool = this._tools[option.getSiblingIndex()];
                tool.toggleDisplay(isSelected);
                option.getComponent(Button).keep = isSelected;
            },
        );
        // add existing tools
        this.toolRoot.getComponentsInChildren(BaseTool).forEach((tool) => this.addTool(tool));
        this.view.scaleScalar = Game.config.orientationConfig.orientationScale ?? 1;
        this.node.zIndex = 1000;
    }

    public addTool(tool: BaseTool) {
        if (this._tools.includes(tool)) {
            return;
        }
        this._tools.push(tool);
        this._displayToolIndexSelector.updateOptions(Array.from({ length: this._tools.length }, (_, i) => i));
        tool.addToRoot(this.toolRoot);
        tool.toggleDisplay(this._displayToolIndexSelector.value === this._tools.indexOf(tool));
    }

    public toggleDisplay(flag: boolean) {
        this.view.active = flag;
    }
}
